// extracted by mini-css-extract-plugin
export var button = "_bf-7";
export var buttonRow = "_bf-6";
export var fadeIn = "_bf-1";
export var gradient = "_bf-0";
export var panel = "_bf-2";
export var panelIn = "_bf-3";
export var subtitle = "_bf-5";
export var title = "_bf-4";